import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { useApplyModal } from './ApplyModalContext';
export function FinalCTA() {
  const {
    open
  } = useApplyModal();
  return <section className="py-32 px-6 relative bg-navy-950 overflow-hidden" data-id="element-63">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-electric/5 rounded-full blur-[100px] pointer-events-none" data-id="element-64" />
      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-65">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-semibold tracking-tight text-white mb-6" data-id="element-66">
          Find your next big move.
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-xl text-slate-400 mb-10" data-id="element-67">
          Turn your audience signals and creator context into launch
          intelligence — and bring your fans along before it ships.
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} data-id="element-68">
          <Button variant="primary" onClick={open} className="text-base py-4 px-8 shadow-[0_0_30px_-5px_rgba(255,255,255,0.4)]" data-id="element-69">
            Apply to the Creator Lab
          </Button>
        </motion.div>
      </div>
    </section>;
}